<template>
	<md-card v-if="this.$lodash.has(this.ask, 'text')">
		<md-ripple class="ask-content">
			<md-card-header class="positiveresponse-outer">
				<router-link :to="`/asks/${ask._id}/request`" class="remove-link">
					<div class="ask-subject" :style="communityStyle">
						<ul class="list-inline mb-0">
              <li>
                {{$lodash.has(community, 'name') ? community.name + ': ' + (currentAsk.subject ? currentAsk.subject : 'N/A') : (currentAsk.subject ? currentAsk.subject : 'N/A')}}
                <span v-if="currentAsk.matchingCriteria && currentAsk.matchingCriteria.assignment && currentAsk.matchingCriteria.assignment.autoRefill === true" style="vertical-align: middle; margin-left: 6px;">
                  <!-- Green recycle icon SVG -->
                  <svg width="18" height="18" viewBox="0 0 24 24" style="vertical-align: middle;" fill="#004D40">
                    <path d="M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z"/>
                  </svg>
                </span>
              </li>
							<li class="count" v-if="currentAsk.comments.length">{{currentAsk.comments.length}}</li>
						</ul>
					</div>
				</router-link>
				<div :style="communityStyle" class="positiveresponse"> <span v-if="selectedOwner != '' && currentAsk.status != '(7) Closed' && currentAsk.status != '(8) Rejected'">({{selectedOwner}})  &nbsp;&nbsp; </span>{{positiveResponse}} / {{recommendedAdvisors}}</div>
			</md-card-header>
			<md-card-content>
				<div class="md-subhead">
					<div class="row">
						<div class="col-sm-6">
							<ul class="list-unstyled mb-0">
								<li>Status: {{ currentAsk.status }}</li>
								<li>Received: {{ask.createdAt | momentDate }}</li>
                <li>Last Advisor Matched:
                  <span v-if="ask.matchAdviserDate">{{ask.matchAdviserDate | momentDate}}</span>
					        <span v-else>N/A</span>
                </li>
								<li class="ask-dueDate" v-if="ask.dueDate">Due Date: {{ask.dueDate | dateFormat }}</li>
							</ul>
						</div>
						<div class="col-sm-6">
							<ul class="list-unstyled pull-right mb-0">
								<li><span v-if="$lodash.has(createdByMember, 'displayName')">Sender: {{ createdByMember.displayName }}</span></li>
								<li><span v-if="$lodash.has(createdByMember, 'emails')">Email: {{ createdByMember.emails.toString() }}</span></li>
							</ul>
						</div>
					</div>
				</div>
				<p class="mt-10" v-html="nl2br(ask.text.substring(0, 500))"></p>
			</md-card-content>
		</md-ripple>
	</md-card>
</template>
<script>
import API from "../services/API";
export default {
  props: ["ask", "allOwners"],
  data() {
    return {
      api: new API(),
      currentAsk: this.ask,
      createdByMember: {},
      community: {},
      communityStyle: {
        backgroundColor: "white",
        color: "black"
	},
	positiveResponse: 0,
	recommendedAdvisors: 0
    };
  },
  created() {
	this.selectedOwner = this.ask.reserveOwner && this.ask.reserveOwner.email ? this.ask.reserveOwner.email : '';
	const found = this.allOwners.some(el => el.email === this.selectedOwner);
	if (!found) {
		this.selectedOwner = '';
	}
    this.loadData();
  },
  methods: {
    loadData: async function() {
      if (this.currentAsk) {
        if (this.ask.createdByMemberID) {
          this.createdByMember = this.ask.createdByMemberID;
        }
        if (this.ask.community) {
          this.community = this.ask.community;
          if (this.$lodash.has(this.community, 'customSettings')) {
	            this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
              this.communityStyle.color = this.community.customSettings.secondaryColor;
	        }
        }
		var positivecount = 0;
		await this.ask.gives.map(singleGive => {
			if (singleGive.helpaction === 'yes' && singleGive.responseState.currentState === 'Approved') {
				positivecount++;
			}
		});
		this.positiveResponse = positivecount;
		this.recommendedAdvisors = this.ask.recommendedAdvisors.length;
      }
    },
    nl2br (str, replaceMode, isXhtml) {
      var breakTag = (isXhtml) ? '<br />' : '<br>';
      var replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AskRow.vue